import PromoteStage from './PromoteStage';

export default PromoteStage;
